import Layout from "../../components/layout/Layout";
import './index.scss';
import * as PR from "../../prime-modules/index";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const Faq = () => {
    const [search, setSearch] = useState("");
    const [loading, setLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);
    const [faqActiveIndex, setFaqActiveIndex] = useState(null);
    const [categories, setCategories] = useState({});
    const [faqData, setFaqData] = useState({});
    const [filterFaqs, setFilterFaqs] = useState([]);
    const [layoutType, setLayoutType] = useState("");
    const location = useLocation();
    const navigate = useNavigate();
    const tab = new URLSearchParams(location.search).get('tab');
    const query = new URLSearchParams(location.search).get('query');
    const hasScrolled = useRef(false);

    const faqsNew = useSelector(state => state.language?.activelang?.faq);
    const { labels } = useSelector(state => state.language?.activelang);

    useEffect(() => {
        if (faqsNew) {
            setLoading(false);
        }
        if (!faqsNew) return;
        const categoriesData = faqsNew?.categories ? JSON.parse(faqsNew.categories) : {};
        const filteredCategories = Object.keys(categoriesData)
            .filter((key) => categoriesData[key].status !== 0)
            .reduce((acc, key) => {
                acc[key] = categoriesData[key];
                return acc;
            }, {});
        const filteredFaqData = Object.keys(filteredCategories).reduce((acc, key) => {
            if (key.startsWith("FAQNEW")) {
                acc[key] = faqsNew[key] ? JSON.parse(faqsNew[key]) : {};
            }
            return acc;
        }, {});
        const layout = !!faqsNew?.layoutType ? JSON.parse(faqsNew.layoutType) : ""
        const faqKeys = Object.keys(filteredCategories);
        const index = tab ? faqKeys.findIndex(key => filteredCategories?.[key].name?.toLowerCase().includes(tab?.toLowerCase()) || generateSlug(filteredCategories?.[key].name) === tab) : 0;
        if (tab) {
            setActiveIndex(index > 0 ? index : 0);
        }
        setLayoutType(layout)
        setCategories(filteredCategories)
        setFaqData(filteredFaqData);
    }, [faqsNew, tab]);

    useEffect(() => {
        let faqs = [];
        if (layoutType !== "Regular") {
            const categoriesKeys = Object.keys(categories);
            const categorykey = categoriesKeys[activeIndex] ? categoriesKeys[activeIndex] : categoriesKeys[0];
            faqs = faqData?.[categorykey] ? faqData?.[categorykey] : [];
        } else {
            faqs = Object.values(faqData).flat();
        }
        if (search) {
            faqs = faqs.filter((qa) =>
                search
                    ? qa?.question?.toLowerCase().includes(search.toLowerCase()) ||
                    qa?.answer?.toLowerCase().includes(search.toLowerCase())
                    : true
            );
        }
        if (query) {
            const findIndex = faqs.findIndex(f => generateSlug(f.question) === query);
            if (findIndex >= 0) {
                setFaqActiveIndex(findIndex);
            }
        }
        setFilterFaqs(faqs);
    }, [faqData, activeIndex, layoutType, categories, search, query])
    useEffect(() => {
        if (hasScrolled.current) return; // Prevents running again
        setTimeout(() => {
            if (query && filterFaqs?.length) {
                const el = document.getElementById(query);
                if (el) {
                    const offset = 120; // Adjust this value as needed
                    const elementPosition = el.getBoundingClientRect().top + window.scrollY;

                    window.scrollTo({
                        top: elementPosition - offset,
                        behavior: "smooth",
                    });
                }
                hasScrolled.current = true; // Ensures it runs only once
            } else if (filterFaqs?.length) {
                hasScrolled.current = true; // Ensures it runs only once
            }
        }, 100);
    }, [query, filterFaqs]);

    const tabChangeHandler = (index) => {
        const categoriesData = Object.values(categories);
        const tabSlug = generateSlug(categoriesData?.[index]?.name);
        const params = new URLSearchParams();
        if (tabSlug) params.set("tab", tabSlug);
        navigate(`/faq?${params.toString()}`, { replace: true });
    }
    const generateSlug = (text) =>
        text ? text.toLowerCase().replace(/[^\w\s]/g, "").replace(/\s+/g, "-") : "";
    const faqTabChangeHandler = (index) => {
        const fagSlug = generateSlug(filterFaqs[index]?.question);
        if (layoutType !== 'Regular') {
            const categoriesData = Object.values(categories);
            const tabSlug = generateSlug(categoriesData?.[activeIndex]?.name);
            const params = new URLSearchParams();
            if (tabSlug) params.set("tab", tabSlug);
            if (fagSlug) params.set("query", fagSlug);
            navigate(`/faq?${params.toString()}`, { replace: true });
        } else {
            const params = new URLSearchParams();
            if (fagSlug) params.set("query", fagSlug);
            navigate(`/faq?${params.toString()}`, { replace: true });
        }
    }

    return (

        <Layout>
            <div className="faq-section">
                <div className="text-center mb-5 pb-5">
                    <h1>{labels?.LBLN0136}</h1>
                    <p>{labels?.LBLN0137}</p>
                </div>
                {!loading && (
                    <div className="search-input-icon">
                        <label htmlFor="search"><i className="pi pi-search" ></i></label>
                        <PR.InputText placeholder="Search..." id="search" value={search} onChange={(e) => setSearch(e.target.value)}
                            type="search" />
                        <span className="pi pi-chevron-right"></span>
                    </div>
                )}
                <div className="faq-blk mb-5 pb-5">

                    {loading ? (
                        <div className="loading-container">
                            <div className="loading-block text-center">
                                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                            </div>
                        </div>
                    ) :
                        layoutType === "Regular" ? (
                            <>
                                {filterFaqs.length > 0 ? (
                                    <PR.Accordion activeIndex={faqActiveIndex} onTabChange={e => {
                                        setFaqActiveIndex(e.index);
                                        faqTabChangeHandler(e.index);
                                    }}>
                                        {filterFaqs.map((qa, j) => (
                                            <PR.AccordionTab header={qa.question} key={j} id={generateSlug(qa.question)}>
                                                <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
                                            </PR.AccordionTab>
                                        ))}
                                    </PR.Accordion>
                                ) : (
                                    <div style={{ padding: "10px", color: "#999", textAlign: "left" }}>{labels?.LBL0131}</div>
                                )}
                            </>
                        ) : (
                            <PR.TabView className="faq-tabview" activeIndex={activeIndex} onTabChange={e => {
                                setActiveIndex(e.index)
                                tabChangeHandler(e.index);
                                setFaqActiveIndex(null)
                            }}>
                                {Object.entries(categories).map(([categoryKey, category]) => {
                                    return (
                                        <PR.TabPanel header={category.name} key={categoryKey} >
                                            {filterFaqs.length > 0 ? (
                                                <PR.Accordion activeIndex={faqActiveIndex} onTabChange={e => {
                                                    setFaqActiveIndex(e.index);
                                                    faqTabChangeHandler(e.index);
                                                }}>
                                                    {filterFaqs.map((qa, j) => (
                                                        <PR.AccordionTab header={qa.question} key={j} id={generateSlug(qa.question)}>
                                                            <div dangerouslySetInnerHTML={{ __html: qa.answer }} />
                                                        </PR.AccordionTab>
                                                    ))}
                                                </PR.Accordion>
                                            ) : (
                                                <div style={{ padding: "10px" }}>{labels?.LBL0131}</div>
                                            )}
                                        </PR.TabPanel>
                                    );
                                })}
                            </PR.TabView>
                        )
                    }
                </div>
            </div>
        </Layout>
    );
};


export default Faq;
